module.exports = __webpack_public_path__ + "static/img/banner2.c2d9b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clinic/banner2.png
// module id = UKCl
// module chunks = 1